import React, { useState, useEffect } from "react";
import "./SearchTeacher.css";
import Pagination from "../../Components/Pagination/Pagination";
import CollegePageContainer from "../Container/CollegePageContainer";
import { connect } from "react-redux";
import { API } from "../../API";
import SearchCard from "../../Components/SearchCard/SearchCard";
import { filterTeacherCriterias, getClassCategories } from "../../Helper";
import SearchBar from "../../Components/SearchBar/SearchBar";
import { createUserObject } from "../Profile/profile.utils";
import Spinner from "../../Components/Spinner/Spinner";
import { Icon } from "semantic-ui-react";
import Tour from "reactour";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import { type } from "jquery";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import SearchTeacherFilter from "../../Components/SearchTeacherFilter/SearchTeacherFilter";
import { TablePagination } from "@mui/material";
import { notify } from "react-notify-toast";
import SearchECECTeacherFilter from "../../Components/SearchTeacherFilter/SearchECECTeacherFilter";

const MyHires = (props) => {
  // let oldCategory = ""
  // let newCategory = ""
  let [isLoaded, setIsLoaded] = useState(false);
  let [pageNumber, setPageNumber] = useState(1);
  let [myHires, setMyHires] = useState([]);
  let [showCurrentUsers, setShowCurrentUsers] = useState([]); // current page of results
  let [searchResults, setSearchResults] = useState([]); // all search results
  let [searchKeyword, setSearchKeyword] = useState("");
  let [searchLocation, setSearchLocation] = useState("");
  let [searchCategory, setSearchCategory] = useState("");
  let [showTour, setShowTour] = useState(false);
  const [_englishCatExpanded, setEnglishCatExpanded] = useState(false);
  const [_vetCatExpanded, setVetCatExpanded] = useState(false);
  
  let [pageNum, setPageNum] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [currentFilter, setCurrentFilter] = useState({})
  const [paginationInfo, setPaginationInfo] = useState( 
    {total_page: null, total_record: null}
  )

  useEffect(() => {
    const strSearch = window.localStorage.getItem('searchTeacherFilter')
		if(strSearch) {
			const currentSearch = JSON.parse(strSearch)
			setCurrentFilter(currentSearch)
      props.user?.is_childcare_centre ? onSearchECECTeacher({
        ...currentSearch
      }, rowsPerPage) : onSearchTeacher({
        ...currentSearch
      }, rowsPerPage)
		}
    else {
      props.user?.is_childcare_centre ? onSearchECECTeacher({
        ...currentFilter
      }, rowsPerPage) : onSearchTeacher({
        ...currentFilter
      }, rowsPerPage)
    }
  }, []);

  const pages = () => {
    let arr = [];
    if (searchResults.length != 0 && searchResults.length % 10 == 0) {
      for (let i = 1; i <= searchResults.length / 10; i++) {
        arr.push(i);
      }
    } else if (searchResults.length == 0) {
    } else if (searchResults.length != 0 && searchResults.length % 10 != 0) {
      for (let i = 1; i <= searchResults.length / 10 + 1; i++) {
        arr.push(i);
      }
    }
    return arr;
  };

  // Show 10 users per page ------
  // Should allTeachers be changed to populatedMyHiresList??
  let handlePage = (pageNumber, teachers, rowsPerPage = 8) => {
    setShowCurrentUsers(teachers);
    setPageNum(pageNumber);
  };

  const onPageNumChange = (e, value = 0) => {
    props.user?.is_childcare_centre ? onSearchECECTeacher(currentFilter, rowsPerPage, value + 1) : onSearchTeacher(currentFilter, rowsPerPage, value + 1)
  };

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    props.user?.is_childcare_centre ? onSearchECECTeacher(currentFilter, value) : onSearchTeacher(currentFilter, value)
  }

  const categories = getClassCategories();

  const search = ({ keyword, category, location }) => {
    let kw = (keyword !== undefined ? keyword : searchKeyword).toLowerCase();
    let cat = (category !== undefined
      ? category
      : searchCategory
    ).toLowerCase();
    // newCategory = cat
    let catArr = [];
    switch (cat) {
      case "all":
        catArr = [];
        break;
      case "all-eng":
        catArr = categories.filter((c) => c.type === "eng").map((c) => c.value);
        break;
      case "all-vet":
        catArr = categories.filter((c) => c.type === "vet").map((c) => c.value);
        break;
      default:
        catArr = [cat];
        break;
    }

    let loc = (location !== undefined
      ? location
      : searchLocation
    ).toLowerCase();

    if (kw || cat || loc) {
      if (myHires.length > 0) {
        let filteredTeachers = myHires.filter((teacher) => {
          let searchFilter = filterTeacherCriterias(teacher);
          let catMatch = false;
          for (let c of catArr) {
            if (searchFilter.category.includes(c)) catMatch = true;
          }
          if (!catArr.length) catMatch = true;

          return (
            searchFilter.keyword.includes(kw) &&
            searchFilter.location.includes(loc) &&
            catMatch
          );
        });
        handlePage(pageNumber, filteredTeachers);
        setSearchResults(filteredTeachers);
        // oldCategory = cat
      }
    } else {
      setSearchResults(myHires);
      handlePage(pageNumber, myHires);
      // oldCategory = cat
    }
  };

  const onSearchTeacher = (filter, limit, page = 1) => {
    filter.limit = limit
    filter.page = page
    delete filter.full_can_delivers
    delete filter.vetQualificationSearch
    setCurrentFilter(filter)
    setIsLoaded(false);
    API.searchTeacherWithFilter({
      ...filter,
      institution_id: props.institution._id,
      type: 'hired'
    }).then((result) => {
      const allTeachers = result.data.data;
        
        // const myHiresList = props.institution.my_hires.map(
        //   (obj) => obj.teacher_id
        // );
        // console.log("props.institution.my_hires: ", props.institution.my_hires)
        // const populatedMyHiresList = allTeachers.filter((teacher) => {
        //   return myHiresList.includes(teacher._id);
        // });
        setMyHires(allTeachers);
        setSearchResults(allTeachers);
        handlePage(page, allTeachers, limit);
        setPaginationInfo(result.data.paginate)
        setIsLoaded(true);
    })
  }

  const onSearchECECTeacher = (filter, limit, page = 1) => {
    filter.limit = limit
    filter.page = page
    delete filter.full_can_delivers
    delete filter.vetQualificationSearch
    setCurrentFilter(filter)
    setIsLoaded(false);
    API.searchECECTeacherWithFilter({
      ...filter,
      institution_id: props.institution._id,
      type: 'hired'
    })
    .then((result) => {
      const teachers = result.data.data
      setMyHires(teachers);
      setSearchResults(teachers);
      handlePage(page, teachers, limit);
      setPaginationInfo(result.data.paginate)
      setIsLoaded(true);
    }).catch((error) => {
      setIsLoaded(true);
      console.log(error)
    })
  }

  const tabs = [
    {
      text: "Search",
      pathname: "/SearchTeachers",
    },
    {
      text: "My Hires",
      pathname: "/MyHires",
      active: true,
    },
    {
      text: "Favourites",
      pathname: "/FavouriteTeachers",
    },
    {
      text: "Block List",
      pathname: "/BlockedTeachers",
    },
  ];

  const tourSteps = [
    {
      content:
        "At ReadyTeacher we have many certified teachers available for you to choose from. Here's how to find them.",
    },
    {
      content:
        "Use the search functions to find teachers that are suitable to your needs.",
      selector: ".search-teacher-filters",
    },
    {
      content: "Click the profile icon to view their profile in full.",
      selector: ".search-card-profile",
    },
    {
      content:
        "Add the teachers you're interested in to your list of favourites by clicking the heart.",
      selector: ".search-card-heart",
    },
    // {
    //   content: "Click the 'Book Me' button to make a booking for a teacher of your choice.",
    //   selector: ".search-card-book-me"
    // },
    {
      content:
        "If you want to prevent a certain teacher from appearing in your results, click the block button.",
      selector: ".search-card-remove",
    },
  ];

  return (
    <CollegePageContainer
      user={props.user}
      header="Search Educators"
      tabs={tabs}
      viewbookings={props.viewbookings}
    >
      {/* <Tour
        showCloseButton={false}
        accentColor="#79cbca"
        className="tourContent"
        steps={tourSteps}
        isOpen={showTour}
        onRequestClose={() => setShowTour(false)}
      >
        <div className="tour-dot" onClick={() => setShowTour(false)}></div>
      </Tour> */}
      <div className="search-teacher-container">
        { !props.user?.is_childcare_centre ? <SearchTeacherFilter 
          onSearchTeacher={(filter) => onSearchTeacher(filter, rowsPerPage)}
          user={props.user}
        /> : <SearchECECTeacherFilter
          onSearchTeacher={(filter) => onSearchECECTeacher(filter, rowsPerPage)}
          user={props.user}
        /> }
        <div className="search-teacher-main">
          <div className="w-100 d-flex justify-content-between align-items-center">
            {/* <div></div>
            <HoverIcon
              icon="info"
              circular
              inverted
              className="search-help-icon"
              onClick={() => setShowTour(true)}
              text="Click for guide"
            /> */}
          </div>
          <div className="d-flex flex-wrap justify-content-center search-teacher-flexbox">
            {isLoaded ? (
              searchResults.length ? (
                showCurrentUsers.map((user) => {
                  return (
                    <SearchCard
                      user={user}
                      key={user._id}
                      isFaved={props.institution.fav_teacher_list.includes(
                        user._id
                      )}
                      isBlocked={
                        props.institution.block_list &&
                        props.institution.block_list.includes(user._id)
                      }
                      showBookTeacherButton
                    />
                  );
                })
              ) : (
                "No results found."
              )
            ) : (
              <Spinner small />
            )}
          </div>

          {searchResults.length && isLoaded ? (
            <div>
              <TablePagination
                component="div"
                count={paginationInfo?.total_record}
                page={pageNum - 1}
                onPageChange={(e, page) => onPageNumChange(e, page)}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[10, 25, 50]}
                size="large"
                onRowsPerPageChange={(e) => handleChangeRowsPerPage(e.target.value)}
                showFirstButton
                showLastButton
              />
            </div>
          ) : null}
        </div>
      </div>
    </CollegePageContainer>
  );
};

// TO DO: update these functions to correct state and function
function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    viewbookings: state.college.permissions.vi_book,
  };
}

const mapDispatchToProps = {
  // addRemoveFavouriteTeacher,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyHires);
